import { isMoment } from 'moment';

export const formikFormData = (object, formData = new FormData(), parentKey = '') => {
    if (object === null || typeof object === 'undefined') {
        return formData;
    }

    Object.keys(object).forEach((key) => {
        const value = object[key];
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;

        if (isMoment(value)) {
            formData.append(fullKey, value);
        } else if (typeof value === 'object' && !Array.isArray(value)) {
            formikFormData(value, formData, fullKey);
        } else if (Array.isArray(value) && value.every((item) => item instanceof Blob)) {
            value.forEach((item, index) => {
                formData.append(`${fullKey}[${index}]`, item, item.name);
            });
        } else if (Array.isArray(value)) {
            // Verificar se o campo tem um nome que indica que é um campo 'list'
            const isListField = fullKey.includes('list') || (fullKey.includes('fields') && value.every((item) => typeof item === 'string'));

            if (isListField) {
                // Para campos do tipo list, enviar cada item como um valor separado com o mesmo nome
                value.forEach((item) => {
                    formData.append(`${fullKey}[]`, item);
                });
            } else {
                // Para outros tipos de arrays
                value.forEach((item, index) => {
                    const itemKey = `${fullKey}[${index}]`;

                    if (typeof item === 'object' && item !== null) {
                        formikFormData(item, formData, itemKey);
                    } else if (item !== undefined && item !== null) {
                        formData.append(itemKey, item);
                    }
                });
            }
        } else if (typeof value === 'boolean') {
            formData.append(fullKey, value ? 1 : 0);
        } else {
            formData.append(fullKey, value);
        }
    });

    return formData;
};

export const formikFormDataWithFiles = (object, formData = new FormData(), parentKey = '') => {
    if (object === null || typeof object === 'undefined') {
        return formData;
    }

    // Verificar se o objeto é circular (para evitar recursão infinita)
    if (parentKey.split('[').length > 10) {
        console.warn('Possível objeto circular detectado em formikFormDataWithFiles. Limitando a profundidade da recursão.');
        return formData;
    }

    Object.entries(object).forEach(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        if (value instanceof Blob || value instanceof File) {
            // Se for um arquivo (Blob/File), adiciona diretamente
            formData.append(fullKey, value, value.name);
        } else if (Array.isArray(value)) {
            // Verificar se o campo tem um nome que indica que é um campo 'list'
            // Podemos identificar isso pelo nome do campo ou pelo contexto
            const isListField = fullKey.includes('list') || (fullKey.includes('fields') && value.every((item) => typeof item === 'string'));
            if (isListField) {
                // Para campos do tipo list, enviar cada item como um valor separado com o mesmo nome
                // Isso permite que a API receba o array corretamente
                value.forEach((item, index) => {
                    formData.append(`${fullKey}[]`, item);
                });
            } else {
                // Tratamento normal para outros tipos de arrays
                value.forEach((item, index) => {
                    const itemKey = `${fullKey}[${index}]`;

                    if (item instanceof Blob || item instanceof File) {
                        // Se for um array de arquivos
                        formData.append(itemKey, item, item.name);
                    } else if (typeof item === 'object' && item !== null) {
                        // Se for um objeto, faz a recursão
                        formikFormData(item, formData, itemKey);
                    } else if (item !== undefined && item !== null) {
                        // Se for um valor primitivo
                        formData.append(itemKey, item);
                    }
                });
            }
        } else if (typeof value === 'object' && value !== null) {
            // Se for um objeto, faz a recursão para transformar em FormData
            formikFormData(value, formData, fullKey);
        } else if (typeof value === 'boolean') {
            // Converte booleanos para 1 e 0
            formData.append(fullKey, value ? '1' : '0');
        } else if (value !== undefined && value !== null) {
            // Adiciona valores normais (string, número, etc.)
            formData.append(fullKey, value);
        }
    });

    return formData;
};
